import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pengajuanGajiService from "../../services/pengajuanGajiService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pengajuan_gaji: false,
    data_pengajuan_gaji: [],
    showMessage:false,
    message:'',
}


export const getDataPengajuanGaji = createAsyncThunk('pengajuan_gaji/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanGajiService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const pengajuanGajiSlice = createSlice({
    name: 'pengajuan_gaji',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengajuan_gaji = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengajuanGaji.fulfilled, (state, action) => {
                state.loading_pengajuan_gaji = false
                state.data_pengajuan_gaji = action.payload??[]
            })
            .addCase(getDataPengajuanGaji.pending, (state) => {
                state.loading_pengajuan_gaji = true
            })
            .addCase(getDataPengajuanGaji.rejected, (state, action) => {
                state.loading_pengajuan_gaji = false
                state.data_pengajuan_gaji = action.payload
            })
    },
})

export const {
    showLoading,
} = pengajuanGajiSlice.actions

export default pengajuanGajiSlice.reducer
